export const LOAN_LOADING = "LOAN_LOADING";
export const LOAN_RESET = "LOAN_RESET";
export const GET_LOAN = "GET_LOAN";
export const GET_LOAN_SUCCESS = "GET_LOAN_SUCCESS";
export const GET_LOAN_FAIL = "GET_LOAN_FAIL";
export const DELETE_LOAN = "DELETE_LOAN"
export const DELETE_LOAN_SUCCESS = "DELETE_LOAN_SUCCESS"
export const DELETE_LOAN_FAIL = "DELETE_LOAN_FAIL"
export const UPDATE_LOAN = "UPDATE_LOAN"
export const UPDATE_LOAN_SUCCESS = "UPDATE_LOAN_SUCCESS"
export const UPDATE_LOAN_FAIL = "UPDATE_LOAN_FAIL"
export const ADD_NEW_LOAN = "ADD_NEW_LOAN"
export const ADD_LOAN_SUCCESS = "ADD_LOAN_SUCCESS"
export const ADD_LOAN_FAIL = "ADD_LOAN_FAIL"